import { useTranslation } from "react-i18next"

import { formatNumber } from "../../utilities/format"
import { useOnlineStatus } from "../../components/Hooks/useOnlineStatus"
import { TableTotalsFooter } from "../../components/DataTable/TableTotals"

type GeologyCrushingTableFooterProps = {
  totalLoads?: number
  totalTonnes?: number
  isLoading: boolean
}

const GeologyCrushingTableFooter: React.FC<GeologyCrushingTableFooterProps> = ({
  totalLoads,
  totalTonnes,
  isLoading
}) => {
  const { t } = useTranslation("geology");
  const isOnline = useOnlineStatus();
  const tonnesDisplay = !isOnline && !totalTonnes
    ? t("totals.tbc")
    : totalTonnes != null ? formatNumber(Math.round(totalTonnes)) : '';
  return (
    <TableTotalsFooter
      isLoading={isLoading}
      totals={[
        { label: t("totals.loads"), value: formatNumber(totalLoads) },
        { label: t("totals.tonnes"), value: tonnesDisplay }
      ]}
    />
  )
}

export default GeologyCrushingTableFooter
